import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import { logout } from '../../core/services/authService';
import { LOGOUT } from '../../core/store/slice/authSlice';
import { useDispatch } from 'react-redux';
import CancelIcon from '@mui/icons-material/Cancel';
import { Navigate, redirect, useLocation, } from 'react-router-dom';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function RoutesLogout({ routesLogout, setRoutesLogout, locationPath, setLocationPath }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClose = async () => {
        setRoutesLogout(false)
        setLocationPath('')
    }
    const handleLogout = async () => {
        const token = localStorage.getItem('token');
        const res = await logout(token);
        setRoutesLogout(false);
        dispatch(LOGOUT());
        localStorage.clear();
        sessionStorage.clear();
        navigate(locationPath, { replace: true });



    }
    return (
        <React.Fragment>
            <BootstrapDialog aria-labelledby="customized-dialog-title"
                open={routesLogout}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Logout
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CancelIcon />
                </IconButton>
                <DialogContent dividers>
                    <Typography gutterBottom style={{ fontWeight: '500', textAlign: 'center' }}>
                        Are you sure you want to logout this account?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleClose}
                    >
                        No
                    </Button>
                    <Button
                        color="error"
                        autoFocus
                        onClick={handleLogout}

                    >
                        Connect, Logout
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}
